module.exports = __webpack_public_path__ + "img/3000.7e5431be.jpg";